import { observer } from 'mobx-react';
import * as React from 'react';
import GroupStore from '../../../GroupStore';
import GroupsStore from '../../../GroupsStore';
import { MulticheckStore } from '../../../Multicheck/Store';
import ModalStore from '../../Modal/Store';
import GroupsView from './GroupsView';
import { GroupResource } from '../../../GroupsStore/Types';
import Skeleton from '../Participants/Skeleton';

interface Props {
  store: GroupsStore;
  modalStore: ModalStore;
  groupStore: GroupStore;
  multicheckStore: MulticheckStore<GroupResource>;
}

const GroupsState: React.FC<Props> = ({ store, modalStore, groupStore, multicheckStore }) => {
  switch (store.state.kind) {
    case 'initializing':
    case 'loading':
    case 'loading-more':
      return <Skeleton filterCount={4} tableColCount={6} checkBoxRequirement="required" />;
    case 'ready':
    case 'updating-query':
    case 'updating-search-parameters':
    case 'sorting':
      return (
        <GroupsView
          groupsStoreState={store.state}
          store={store}
          modalStore={modalStore}
          groupStore={groupStore}
          multicheckStore={multicheckStore}
        />
      );
    case 'error':
      return <>{store.state.message}</>;
  }
};

export default observer(GroupsState);
